export default __webpack_public_path__ + "static/media/PokiRoverKit.145898fa.png";